import { Switch } from "@/components/ui/switch";
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";

interface SwitchInputFieldProps extends FormFieldComponentProps {
  onCheckedChange?: (_checked: boolean) => void;
}

/**
 * Switch input field component for forms.
 * Provides a toggle switch interface for boolean values.
 *
 * @component
 * @example
 * <SwitchInputField
 *   form={form}
 *   name="isEnabled"
 *   label="Enable feature"
 *   disabled={false}
 * />
 */
function SwitchInputField({ form, name, label, disabled, className, onCheckedChange }: SwitchInputFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={`flex items-center space-x-3 w-full ${className || ""}`}>
          <div className="flex items-center">
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={(checked) => {
                  if (onCheckedChange) {
                    onCheckedChange(checked);
                  } else {
                    field.onChange(checked);
                  }
                }}
                disabled={disabled}
              />
            </FormControl>
            {label && <FormLabel className="font-light ml-2">{label}</FormLabel>}
          </div>
        </FormItem>
      )}
    />
  );
}

export default SwitchInputField;
